import $ from "jquery";
import compositeFields from "./CompositeFields";

$(document).on("click", ".repeat-template-action-button", (e) => {
  e.preventDefault();
  const selectedOption = $(e.currentTarget);
  const id = selectedOption
    .attr("id")
    .replace("repeat-template-", "repeatFields-template-");
  const template = $("#" + id);
  const info = $(
    "#" + id.replace("repeatFields-template-", "repeated-sections-"),
  );
  const index = parseInt(info.data("sections"), 10) + 1;
  const max = parseInt(info.data("max-repeats"), 10);

  if (index - 1 >= max) {
    alert("Max reached");
    return;
  }

  const clone = document.importNode(template[0].content, true);
  const renderer = document.createElement("div");
  renderer.classList.add("repeated-sections__container");
  renderer.appendChild(clone);
  $(renderer).data("index", index);

  const inner = JSON.stringify(renderer.innerHTML);
  const test = inner.replace(new RegExp("replaceme", "g"), index + "");

  renderer.innerHTML = JSON.parse(test);
  info[0].appendChild(renderer);

  info.data("sections", index);
  compositeFields();
});
$(document).on("click", ".js-delete-repeatable-section", (e) => {
  e.preventDefault();
  const selectedOption = $(e.currentTarget);
  const id = selectedOption
    .attr("id")
    .replace("delete-repeatable-", "repeatable-");
  const template = $("#" + id);
  const info = template.parents(".repeated-sections");
  template.parent().remove(); // option 4

  const children = info.find(".repeated-sections__container");
  children.each(function (index, element) {
    const oldIndex = $(this).data("index");
    const inner = JSON.stringify(element.innerHTML);
    const tpl = `<span class=\\"section-index\\">${oldIndex}</span>`;
    const test = inner
      .replace(tpl, `<span class=\\"section-index\\">${index + 1}</span>`)
      .replace(new RegExp(`\-${oldIndex}\-`, "g"), `-${index + 1}-`)
      .replace(new RegExp(`\\[${oldIndex}\\]`, "g"), `[${index + 1}]`);

    $(this).data("index", index + 1);
    element.innerHTML = JSON.parse(test);
  });
});
